import { render, staticRenderFns } from "./ExtraAttributes.vue?vue&type=template&id=287995ca"
import script from "./ExtraAttributes.vue?vue&type=script&lang=js"
export * from "./ExtraAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports